import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const Item = styled(Paper)(({ theme, bgcolor, bordercolor }) => ({
    backgroundColor: bgcolor || (theme.palette.mode === 'dark' ? '#1A2027' : '#fff'),
    borderColor: bordercolor || 'transparent',
    borderWidth: '1px',
    borderStyle: 'solid',
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    padding: '35px 0px',
    borderRadius: '8px', // Adjust this value to make the corners more rounded
}));

const Title = styled(Typography)(({ titlecolor }) => ({
    color: titlecolor || '#000',
    fontWeight: 'bold',
    fontSize: '2rem', // Adjust this value to make the title bigger
}));

const Description = styled(Typography)(({ descriptioncolor }) => ({
    color: descriptioncolor || '#666',
}));

const KeyMetricsCard = ({ bgcolor, bordercolor, title, titlecolor, description, descriptioncolor }) => (
    <Item bgcolor={bgcolor} bordercolor={bordercolor}>
        <Title titlecolor={titlecolor} variant="h6">
            {title}
        </Title>
        <Description descriptioncolor={descriptioncolor} variant="body2">
            {description}
        </Description>
    </Item>
);

export default KeyMetricsCard;